import React, { useState, useMemo } from 'react';
import MaterialTable from 'material-table';
import { Tooltip, IconButton, withStyles, Fab, Typography } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import * as actions from './store/translateActions';
import * as action from '../../np-core/Auth/store/authActions';
import { isSuperUser } from '../../sc-utilities';
import { connect } from 'react-redux';
import TranslateDelete from './TranslateDelete'
import { hasPermission, BackButton, localization, getDimensionsOfPagination } from '../../sc-utilities';
import { CloudDownload, CloudUpload, Refresh } from "@material-ui/icons";

const styles = theme => ({
    "@global": {
        "[class*='data-react-beautiful-dnd-drag-handle']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='MuiDialogContent-root']": {
            overflowX: 'hidden',
            flex: ' 1 1 auto',
            padding: '8px 24px'
        },
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    customToolbar: {
        marginLeft: 14,
        paddingTop: '4px',
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        paddingTop: '4px',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    },
    fab: {
        textTransform: "none",
        width: '50%',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        marginTop: "10px"
    },
    dialog: {
        width: 'auto',
        overflow: 'hidden'
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    progress: {
        width: `398px`,
        height: "400px"
    },
    typographyTo: {
        marginTop: "5px",
        color: theme.palette.buttonText.default,
    },
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const TranslationList = props => {
    const { classes, permissions, translations, fetchTranslationCount, goToUploadTranslations, deleteModalState, saveColumnsFilter, activeCustomer, tableColumns, translation, fetchTranslation, tableActions, tableRef, handleDownload } = props;
    const fetching = translation.fetching;
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []); const [tableOptions, setTableOptions] = useState({
            filtering: true,
            sorting: false,
            exportFileName: 'UserActivity',
            search: false,
            minBodyHeight: window.innerHeight - 238 < 300 ? 300 : window.innerHeight - 238,
            maxBodyHeight: window.innerHeight - 238,
            pageSizeOptions: rowsPageSizeInit,

            exportButton: false,
            rowStyle: (_rowData, index) => {
                return { backgroundColor: index % 2 ? '#f3f3f3' : '#ffffff' };
            }, columnsButton: true,
            pageSize: pageSize ? pageSize : 50,
            emptyRowsWhenPaging: false
        });

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    }

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);

        query['ActiveCustomerID'] = activeCustomer;
        query['q'] = q;
        let count = await fetchTranslationCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await fetchTranslation(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`Translations`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        return newColumnState
    }

    const tableTitle = () => {
        return <div className={classes.customToolbar}>
            <div className={classes.tableTitle}>
                {BackButton(translations, classes.customTooltip)}
                <Typography>     {translations["translations"] || "Translations"}</Typography>
                {hasPermission(permissions, "translation_create") ? (
                    <Fab
                        variant="extended"
                        size="small"
                        style={{ borderRadius: '1px' }}
                        color="primary"
                        aria-label="Add"
                        className={classes.fab}
                        onClick={props.goToCreateTranslations}
                    >
                        <Add size="small" />
                        {translations["create_new"] || "Create new"}
                    </Fab>
                ) : null}
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
            <>
                {hasPermission(permissions, "import_translate") ? (
                    <Tooltip title={translations["import_translation"] || "Import translation"}>
                        <IconButton aria-label={translations["import_translation"] || "Import translation"} value='csv'
                            onClick={() => goToUploadTranslations()}>
                            <CloudUpload />
                        </IconButton>
                    </Tooltip>
                ) : null}
                {hasPermission(permissions, "export_translate") ? (

                    <Tooltip title={translations["export_translation"] || "Export translation"}>
                        <IconButton aria-label={translations["export_translation"] || "Export translation"} value='csv' onClick={handleDownload}>
                            < CloudDownload />
                        </IconButton>
                    </Tooltip>
                ) : null}
            </>
        </div>
    }
    const handleCloseDanger = async () => {
        if (deleteModalState.open) {
            await props.deleteTranslation({ TranslationID: deleteModalState.translationID, ActiveCustomerID: activeCustomer });
            props.handleDelete();
            tableRef.current && tableRef.current.onQueryChange()
        }
    }

    return (<><MaterialTable
        tableRef={tableRef}
        title={tableTitle()}
        columns={columnObject}
        data={fetchTableData}
        options={tableOptions}
        onChangeRowsPerPage={(size) => {
            setTableOptions({ ...tableOptions, pageSize: size })
            pageSize = size
        }}

        isLoading={fetching}
        localization={localization(translations)}
        onChangeColumnHidden={columnHidden}
        actions={isSuperUser() ? tableActions : null}
        onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
    />
        {hasPermission(permissions, "translation_delete") ? (
            <TranslateDelete
                activeCustomer={activeCustomer}
                deleteModalState={deleteModalState}
                entityName={"Permission"}
                translations={translations}
                handleDelete={props.handleDelete}
                handleCloseDanger={handleCloseDanger}
            />
        ) : null}

    </>)
}

const mapDispatchToProps = dispatch => {
    return {
        fetchTranslationCount: filterParams => dispatch(actions.fetchTranslationsCount(filterParams)),
        fetchTranslation: filterParams => dispatch(actions.fetchTranslations(filterParams)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        deleteTranslation: filterParams => dispatch(actions.deleteTranslation(filterParams)),

    };
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translation: state.translate.translations,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TranslationList));